export default __webpack_public_path__ + "static/media/Rectangle_85.e87c4497.png";